/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Modal, Input, Table, Alert, Typography, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import OptionService from "../../../../service/ERP/Options.service";

const optionService = OptionService();

/**
 * เลือกสินค้า (PG) จากระบบ — ใช้ทั้งตอนกรอก Proforma Invoice
 * และตอนจับคู่ชื่อสินค้าอิสระของ PI เข้ากับรหัสสินค้าจริงก่อนออก Invoice
 *
 * confirm(row) → { pg_code, pg_name, unit_cs, ... }
 */
export default function ModalPickProduct({ open, close, confirm, hintName }) {
  const [rows, setRows] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setKeyword(hintName || "");
    setLoading(true);
    optionService
      .optionsPG({ p: "cus" })
      .then((res) => setRows(res.data?.data || []))
      .catch(() => message.error("โหลดรายการสินค้าไม่สำเร็จ"))
      .finally(() => setLoading(false));
  }, [open]);

  const data = useMemo(() => {
    const k = keyword.trim().toLowerCase();
    if (!k) return rows;
    return rows.filter((r) =>
      [r.pg_code, r.pg_name, r.pg_ivname, r.code]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(k))
    );
  }, [rows, keyword]);

  const columns = [
    { title: "รหัสสินค้า", dataIndex: "pg_code", width: 130 },
    { title: "ชื่อสินค้า", dataIndex: "pg_name" },
    { title: "ชื่อบน Invoice", dataIndex: "pg_ivname", width: 220 },
    { title: "Pcs/Ctn", dataIndex: "unit_cs", width: 90, align: "right" },
  ];

  const handlePick = (record) => {
    confirm?.(record);
    close?.(false);
  };

  return (
    <Modal
      open={open}
      onCancel={() => close?.(false)}
      footer={null}
      width={900}
      title="เลือกสินค้าจากระบบ"
      destroyOnClose
    >
      {hintName ? (
        <Alert
          type="info"
          showIcon
          className="!mb-3"
          message={
            <span>
              ชื่อที่กรอกไว้ใน Proforma Invoice :{" "}
              <Typography.Text strong>{hintName}</Typography.Text>
            </span>
          }
        />
      ) : null}

      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder="ค้นหารหัส / ชื่อสินค้า"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        className="!mb-3"
      />

      <Table
        size="small"
        rowKey={(r) => `${r.item_type}-${r.pg_code}`}
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 10, showSizeChanger: false }}
        scroll={{ y: 360 }}
        onRow={(record) => ({
          onClick: () => handlePick(record),
          style: { cursor: "pointer" },
        })}
      />
    </Modal>
  );
}
